import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError, TimeoutError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';

import { LoadingService } from '../../loading.service';
import { HTTP_SILENT_REQUEST } from '../constants/http-slient-request.constant';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  const url: string = req.url;
  if (url.startsWith('/assets')) {
    return next(req);
  }

  if (req.headers.has('x-silent-header') || req.context.has(HTTP_SILENT_REQUEST)) {
    // console.log('silent', req.headers.has('x-silent-header'));
    return next(req);
  }

  loadingService.showSpinner();

  return next(req).pipe(
    timeout(30000),
    catchError((error: Error) => {
      if (error instanceof TimeoutError) {
        alert(new Error('Request Timeout'));
      }
      return throwError(() => error);
    }),
    finalize(() => loadingService.hideSpinner())
  );
};
